import React from "react";
import { Link } from "react-router-dom";
import { GRADE_BADGE, STATUS_BADGE, CATEGORY_LABELS, fmtMoney, fmtPct } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function NoteCard({ note, onMakeOffer, compact = false }) {
  return (
    <div data-testid={`note-card-${note.note_id}`}
         className="border border-border bg-card hover-lift flex flex-col">
      <Link to={`/notes/${note.note_id}`} className="block aspect-[16/10] overflow-hidden bg-muted">
        <img src={note.vehicle_photo} alt={`${note.vehicle_make} ${note.vehicle_model}`}
             className="w-full h-full object-cover" loading="lazy" />
      </Link>
      <div className="p-5 flex flex-col gap-4 flex-1">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="font-overline text-muted-foreground">{note.vehicle_year} · {note.state}</div>
            <h3 className="font-display text-xl leading-tight mt-1">
              {note.vehicle_make} {note.vehicle_model}
            </h3>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className={`px-2 py-0.5 text-[10px] font-mono-data uppercase tracking-wider ${GRADE_BADGE[note.grade]}`}
                  data-testid={`grade-badge-${note.note_id}`}>Grade {note.grade}</span>
            <span className={`px-2 py-0.5 text-[10px] font-mono-data uppercase tracking-wider ${STATUS_BADGE[note.category]}`}
                  data-testid={`status-badge-${note.note_id}`}>{CATEGORY_LABELS[note.category]}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-2 border-t border-border pt-4">
          <Metric label="Est. Yield" value={fmtPct(note.estimated_yield)} highlight />
          <Metric label="Balance" value={fmtMoney(note.remaining_balance)} />
          <Metric label={
            note.payment_frequency === "monthly" ? "Monthly Pmt" :
            note.payment_frequency === "biweekly" ? "Bi-wk Pmt" : "Weekly Pmt"
          } value={fmtMoney(note.weekly_payment)} />
          <Metric label="Term Left" value={`${note.remaining_term_weeks} ${
            note.payment_frequency === "monthly" ? "mo" :
            note.payment_frequency === "biweekly" ? "biwk" : "wk"
          }`} />
          <Metric label="Asking" value={fmtMoney(note.asking_price)} />
          <Metric label="Rate" value={fmtPct(note.interest_rate)} />
        </div>

        {!compact && (
          <div className="grid grid-cols-2 gap-2 mt-auto pt-2">
            <Button asChild variant="outline" className="rounded-none uppercase text-xs tracking-wider">
              <Link to={`/notes/${note.note_id}`} data-testid={`view-details-${note.note_id}`}>View Details</Link>
            </Button>
            <Button onClick={() => onMakeOffer?.(note)} data-testid={`make-offer-${note.note_id}`}
                    className="rounded-none uppercase text-xs tracking-wider">Make Offer</Button>
          </div>
        )}
      </div>
    </div>
  );
}

function Metric({ label, value, highlight }) {
  return (
    <div>
      <div className="font-overline text-muted-foreground">{label}</div>
      <div className={`font-mono-data text-base ${highlight ? "text-primary font-semibold" : ""}`}>{value}</div>
    </div>
  );
}
